import { BaseEditItemStore } from "@leap4/frontend";
import { IOrganizationAdvertiserLogin } from "../../interfaces/IOrganizationAdvertiserLogin";

export class AddOrganizationStore extends BaseEditItemStore<IOrganizationAdvertiserLogin>{
    entityName: string = "Organization";
}
